/**
 * @generated SignedSource<<ac41bba8d0cfd9b291875518de0cf5d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LinearImportIssuePreviewQuery$variables = {
  id: string;
};
export type LinearImportIssuePreviewQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly linear: {
        readonly id: string;
        readonly isConnected: boolean;
        readonly issuePreview: {
          readonly allStates: ReadonlyArray<{
            readonly color: string;
            readonly externalId: string;
            readonly name: string;
            readonly type: string;
          }>;
          readonly assignee: {
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
          } | null;
          readonly due: string | null;
          readonly externalId: string | null;
          readonly externalIdentifier: string | null;
          readonly name: string;
          readonly state: {
            readonly color: string;
            readonly externalId: string;
            readonly name: string;
            readonly type: string;
          } | null;
          readonly teamName: string | null;
        } | null;
        readonly organizationUrlKey: string;
      } | null;
    };
  };
};
export type LinearImportIssuePreviewQuery = {
  response: LinearImportIssuePreviewQuery$data;
  variables: LinearImportIssuePreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationUrlKey",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalIdentifier",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "due",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v12 = [
  (v5/*: any*/),
  (v7/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v5/*: any*/),
  (v7/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinearImportIssuePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LinearUserNode",
                "kind": "LinkedField",
                "name": "linear",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "LinearIssuePreviewNode",
                    "kind": "LinkedField",
                    "name": "issuePreview",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinearStateNode",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinearStateNode",
                        "kind": "LinkedField",
                        "name": "allStates",
                        "plural": true,
                        "selections": (v12/*: any*/),
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinearImportIssuePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LinearUserNode",
                "kind": "LinkedField",
                "name": "linear",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v4/*: any*/),
                    "concreteType": "LinearIssuePreviewNode",
                    "kind": "LinkedField",
                    "name": "issuePreview",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinearStateNode",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinearStateNode",
                        "kind": "LinkedField",
                        "name": "allStates",
                        "plural": true,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f01f2c5a420c8c8bea691960842cf10",
    "id": null,
    "metadata": {},
    "name": "LinearImportIssuePreviewQuery",
    "operationKind": "query",
    "text": "query LinearImportIssuePreviewQuery(\n  $id: String!\n) {\n  viewer {\n    integrations {\n      linear {\n        id\n        isConnected\n        organizationUrlKey\n        issuePreview(issueId: $id) {\n          externalId\n          externalIdentifier\n          name\n          teamName\n          due\n          state {\n            externalId\n            name\n            type\n            color\n            id\n          }\n          allStates {\n            externalId\n            name\n            type\n            color\n            id\n          }\n          assignee {\n            id\n            fullName\n            image\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "74af5598d398180719c2fe7226865900";

export default node;
